module.exports = __webpack_public_path__ + "img/nikapu.2f9673ef.png";